module.exports = __webpack_public_path__ + "static/Kaizen_Carvao-929c805b21e4a5207527108c97dd903c.jpg";